import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'fs-appliance-dashboard-header',
  templateUrl: './appliance-dashboard-header.component.html',
  styleUrls: ['./appliance-dashboard-header.component.scss'],
})
export class ApplianceDashboardHeaderComponent {
  @Input()
  public applianceName: string;

  @Output()
  public readonly editAppliance = new EventEmitter<void>();

  public onEditAppliance(): void {
    this.editAppliance.emit();
  }
}
